module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_CJEnM_m2.7e302eeecb99450f64c73c72cf7afc23.png";